<script setup lang="ts">
import ErrorMessage from '@/overlays/ErrorMessage.vue';
import { eventBus } from '@/utils/eventBus';
import { onBeforeUnmount, onMounted, ref } from 'vue';

const visible = ref(false);

const handleError = () => {
  visible.value = true;
};

onMounted(() => {
  eventBus.on('anErrorOccurred', handleError);
});

onBeforeUnmount(() => {
  eventBus.off('anErrorOccurred', handleError);
});
</script>

<template>
  <ErrorMessage v-if="visible" @close="visible = false" />
</template>
